import styled from 'styled-components';

import { fadeIn } from '../../styles/shared.style';

export const NoTickets = styled.div<{ $reduceHeight : boolean}>`
    display: flex;
    width: 100%;
    min-height: ${({ $reduceHeight }) => $reduceHeight ? 'calc(100vh - 185px - 60px)' : 'calc(100vh - 185px)'};
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 0 1.5rem;
    text-align: center;
    opacity: 1;
    animation: ${fadeIn} 3s forwards;
`;

export const Image = styled.img`
    width: 191px;
    max-width: 174px;
    height: auto;
`;

export const Title = styled.strong`
    font-family: 'Elza', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
`;

export const Subtitle = styled.p`
    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
`;

export const CtaButton = styled.button`
  width: 100%;
  max-width: 360px;
  padding: 12px 28px;
  background: ${({ theme }) => theme.colors.button.surface.primary};
  color: ${({ theme }) => theme.colors.button.text.primary};
  border: none;
  border-radius: 8px;
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.button.hover.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.button.surface.primary};
    outline-offset: 2px;
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.button.surface.disabled};
    color: ${({ theme }) => theme.colors.button.text.disabled};
    cursor: not-allowed;
  }
`;

export const OutlineCtaButton = styled.button`
  padding: 12px 24px;
  background: transparent;
  color: ${({ theme }) => theme.colors.button.surface.primary};
  border: 2px solid ${({ theme }) => theme.colors.button.surface.primary};
  border-radius: 8px;
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.button.surface.primary};
    color: ${({ theme }) => theme.colors.button.text.primary};
  }

  &:disabled {
    border-color: ${({ theme }) => theme.colors.button.surface.disabled};
    color: ${({ theme }) => theme.colors.button.text.disabled};
    cursor: not-allowed;
  }
`;
